import {
  Box, Checkbox, DashboardModule, ListItem, Text,
} from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'

import BrandImageListItem from '../BrandImages/BrandImageListItem'
import useBrandEditMediaReviewer from './hooks/useBrandEditMediaReviewer'

interface BrandEditMediaReviewerProps {
  brandPayload: ReturnType<typeof useBrand>,
}

const BrandEditMediaReviewer = (props: BrandEditMediaReviewerProps) => {
  const {
    brandPayload: {
      brand: {
        id,
      },
      callbacks: {
        manageBrandPublicLinkSettingsModal,
        manageBrandPublicLinkAttachments,
      },
      loading,
    },
  } = props

  const editMediaReviewerPayload = useBrandEditMediaReviewer({ brandId: id })
  const {
    brandedMediaReviewerCheckboxItems,
    publicLinkCoverImage,
    publicLinkCoverImageFileName,
    publicLinkCoverImageUrl,
    publicLinkLogo,
    publicLinkLogoFileName,
    publicLinkLogoUrl,
  } = editMediaReviewerPayload

  return (
    <DashboardModule loading={loading} title="Media & Artwork Review Branding">
      {!loading && (
        <Box flexDirection="column">
          <BrandImageListItem
            callbacks={{
              launchModalFn: () => manageBrandPublicLinkAttachments(publicLinkLogo),
            }}
            fileName={publicLinkLogoFileName}
            imageBackgroundSize="contain"
            imageUrl={publicLinkLogoUrl}
            title="Media & Artwork Review Logo"
          />

          <BrandImageListItem
            callbacks={{
              launchModalFn: () => manageBrandPublicLinkAttachments(publicLinkCoverImage),
            }}
            fileName={publicLinkCoverImageFileName}
            imageBackgroundSize="cover"
            imageUrl={publicLinkCoverImageUrl}
            title="Cover Image"
          />

          <ListItem
            boxProps={{
              alignItems: 'center',
              borderBottom: '1px solid',
              fontSize: 'small',
              justifyContent: 'start',
              lineHeight: 1.3,
              padding: 'large',
            }}
            onClick={() => manageBrandPublicLinkSettingsModal()}
            showAngleIcon
          >
            <Box flexDirection="column">
              <Text color="bodyFontColor">Branding &amp; Disclaimers</Text>

              {brandedMediaReviewerCheckboxItems.map(item => (
                // @ts-expect-error TS2339
                <ListItem.WithCheckbox
                  boxProps={{ border: 'none', paddingY: 'none' }}
                  checkbox={(
                    <Checkbox
                      checked={item.value}
                      fontSize="small"
                    />
                  )}
                  disableHover
                  key={item.key}
                >
                  <Text color="bodyFontLightColor" fontSize="xsmall">
                    {item.title}
                  </Text>
                  {/*
                 // @ts-expect-error TS2339 */}
                </ListItem.WithCheckbox>
              ))}
            </Box>
          </ListItem>
        </Box>
      )}
    </DashboardModule>
  )
}

export default BrandEditMediaReviewer
